/// @ts-check
import axios from 'axios';
import url from '../url.js';

/**
 * @typedef {import('../types/groupContext.types.js').GroupContext} GroupContext
 * @typedef {import('../types/groupContext.types.js').ConversationHistoryItem} ConversationHistoryItem
 * @typedef {import('../types/groupContext.types.js').UserMessage} UserMessage
 */

const partnerResponseService = {
  /**
   * 當用戶發送訊息時，觸發後端處理夥伴回應（Stateless 版本）
   * @param {string} activityId - 活動 ID
   * @param {string} groupId - 小組 ID
   * @param {UserMessage} userMessage - 用戶消息
   * @param {string[]} partnerIds - 夥伴 ID 列表
   * @param {GroupContext} groupContext - 完整小組上下文（包含 conversationHistory）
   * @param {Object} [activityCoreData] - 活動核心資料（包含 initialNodes）
   * @returns {Promise<any>} 後端回應
   */
  handleUserMessage: async (activityId, groupId, userMessage, partnerIds, groupContext, activityCoreData) => {
    try {
      // 從 groupContext 中提取 conversationHistory
      const conversationHistory = groupContext.conversationHistory || [];
      console.log('[Partner Response Service] 夥伴 conversationHistory:', conversationHistory);
    
      console.log('[Partner Response Service] 處理夥伴回應:', { 
        activityId, 
        groupId, 
        messageId: userMessage.id,
        partnerCount: partnerIds.length,
        historyLength: conversationHistory.length,
        contextVersion: groupContext.contextVersion,
        hasCoreData: !!activityCoreData
      });

      
      // 調用後端 API 處理夥伴回應（傳送完整的 context）
      const response = await axios.post(
        url.backendHost + 'api/partner-response/message',
        {
          activityId,
          groupId,
          partnerIds,
          userMessage: {
            id: userMessage.id,
            content: userMessage.content,
            author: userMessage.author,
            timestamp: userMessage.timestamp || new Date()
          },
          conversationHistory, // 從 groupContext 提取的對話歷史
          groupContext, // 完整的小組 context
          activityCoreData // 活動核心資料（initialNodes）
        },
        { withCredentials: true }
      );
      
      
      return response.data;
    } catch (error) {
      console.error('[Partner Response Service] 觸發失敗:', error);
      return null;
    }
  },

  /**
   * 設定 LLM 提供商
   * @param {string} provider - 提供商名稱
   * @returns {Promise<any>} 設定結果
   */
  setLLMProvider: async (provider) => {
    try {
      const response = await axios.post(
        url.backendHost + 'api/partner-response/llm/provider',
        { provider },
        { withCredentials: true }
      );
      
      return response.data;
    } catch (error) {
      console.error('設定 LLM 提供商失敗:', error);
      throw error;
    }
  },

  /**
   * 獲取 LLM 狀態
   * @returns {Promise<any>} LLM 狀態
   */
  getLLMStatus: async () => {
    try {
      const response = await axios.get(
        url.backendHost + 'api/partner-response/llm/status',
        { withCredentials: true }
      );
      return response.data;
    } catch (error) {
      console.error('獲取 LLM 狀態失敗:', error);
      throw error;
    }
  },

  /**
   * 測試 LLM 提供商
   * @param {string} provider - 提供商名稱
   * @returns {Promise<any>} 測試結果
   */
  testLLMProvider: async (provider) => {
    try {
      const response = await axios.get(
        url.backendHost + `api/partner-response/llm/test/${provider}`,
        { withCredentials: true }
      );
      return response.data;
    } catch (error) {
      console.error(`測試 ${provider} 提供商失敗:`, error);
      throw error;
    }
  }
};

export default partnerResponseService; 